<template>

  <div class="header_page">
      <div class="w1200 mar_auto hp100">
        <div class="flex_box aic hp100">
          <img src="../assets/images/img.png" width="100px" alt=""/>
          <router-link to="/">
            <span  :class="{no:$route.name == 'home'}" class=" home_btn" style="margin: 0">
<!--              {{$route.path}}-->
<!--              {{$route.path == '/exhibitors/lists'}}-->
              HOMEPAGE</span>
          </router-link>

          <a v-show="$route.name != 'home'" href="javascript:history.go(-1)" style="font-size: 16px;color: #FFFFFF;display: flex; margin-left: 20px;cursor: pointer">
            <img width="16" src="../assets/images/ic_return@2x.png">
            <div>  RETURN</div>
          </a>

<!--          <router-link to="/" >-->
<!--            <span  :class="{no:$route.path == '/'}" class=" home_btn" style="margin: 0">   CBE ONLINE PLATFORM</span>-->
<!--          </router-link>-->
          <div class="item ov">
            <div class="search_box" v-if="false" style="width: auto;margin: 0  32px">
              <div class="flex_box hp100">
                <div class="item ov">
                  <div class="re">
                    <input v-model="keywords" type="text" class="ipt_search" placeholder="Please search for keywords"/>
                    <img src="../assets/images/icon_search.png" class="ic_search_pos" alt=""/>
                  </div>
                </div>
                <div
                    @click="$router.push({path:'/search/one',query:{t:t,s:keywords}})"
                >
                  <span class="search_btn">Search</span>
                </div>
              </div>
            </div>
          </div>
          <div class="back_top" @click="scrollToTop();">
            <img src="../assets/images/ic_top.png" class="ic_size" alt=""/>
            <span class="back_name">SCROLL TO TOP</span>
          </div>
          <div class="lang_sw_box">
            <a href="javascript:void(0);" class="item_lang" @click="switchToZh">中</a>
            <a class="item_lang current"  >ENG</a>
          </div>
        </div>
      </div>

    </div>




</template>

<script>
export default {
  name: 'Header',
  props: {},

  data() {
    return {
      t: 2,
      keywords: '',
      tabIndex: 0,
      language: localStorage.getItem("locale") || "zh",
    }
  },
  created() {
    if (this.$route.query.s) {
      this.keywords = this.$route.query.s;
    }
    if (this.$route.query.t) {
      this.t = this.$route.query.t;
    }
  },

  methods: {
    switchToZh() {
      const sceneId = this.getSceneId();
      let href = '/zh/#/exhibitors/lists';
      if (sceneId) {
        href += '?sceneId=' + encodeURIComponent(sceneId);
      }
      window.location.href = href;
    },
    getSceneId() {
      const querySceneId = this.$route.query && this.$route.query.sceneId;
      const hashSceneId = this.getQueryParam('sceneId');
      const storedSceneId = localStorage.getItem('sceneId');
      return querySceneId || hashSceneId || storedSceneId || '';
    },
    getQueryParam(name) {
      const hash = window.location.hash || '';
      const qIndex = hash.indexOf('?');
      if (qIndex === -1) return null;
      const search = hash.substring(qIndex + 1);
      const params = search.split('&');
      for (let i = 0; i < params.length; i++) {
        const pair = params[i].split('=');
        if (decodeURIComponent(pair[0]) === name) {
          return decodeURIComponent(pair[1] || '');
        }
      }
      return null;
    },
    handleLangSw(lange) {
      localStorage.setItem("locale", lange);
      this.$i18n.locale = lange;
      localStorage.setItem("lang", lange);
      this.language = lange;
      location.reload(); //重新加载

    },
    handSearch() {
      // window.location.href = window.location.
      // this.$router.push({
      //   path:"/search/one",
      //   query:{
      //     t:2,
      //     s:this.keywords,
      //   }
      // })
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });
    }

  }

}
</script>

<style scoped lang="less">
.header_page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #A90000;
  z-index: 6;
  overflow: hidden;
}


.home_btn {
  position: relative;
  display: block;
  padding: 0 24px;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  border-width: 0 1px 0 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.2);
  margin-left: 32px;
  margin-right: 32px;
}

.home_btn.no {
  color: #A90000;
  background: #fff;
  border-color: rgba(255, 255, 255, 1);
}

.back_top {
  position: relative;
  display: flex;
  align-items: center;
  height: 60px;
  cursor: pointer;

  .ic_size {
    width: 12px;
    height: 20px;
  }

  .back_name {
    position: relative;
    font-size: 16px;
    color: #fff;
    margin-left: 8px;
  }
}

.lang_sw_box {
  position: relative;
  display: flex;
  margin-left: 32px;

  .item_lang {
    position: relative;
    width: 50px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;

    &.current {
      color: #A90000;
      background: #fff;
    }
  }

}

.search_box {
  position: relative;
  width: 620px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;

  .ipt_search {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
    padding: 0 12px 0 36px;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    background: rgba(255, 255, 255, .2);
    outline: none;
    border: 0;
    border-radius: 0;

    &::-webkit-input-placeholder {
      color: #fff;
    }
  }

  .ic_search_pos {
    position: absolute;
    top: 50%;
    left: 12px;
    width: 16px;
    height: 16px;
    z-index: 2;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
  }

  .search_btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 40px;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    background: #E94A13;
    cursor: pointer;
  }
}

</style>
